import React from 'react';
import _, { get } from 'lodash';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';

const VehicleInformation = ({ transactionInfo, handleTagUnit}) => {
  const vehicleInfo = _.get(transactionInfo, 'included.vehicles')
  const isStartAssessment = get(transactionInfo, 'included.transaction_history.attributes.is_start_assessment');
  const permissions = getJson('permissions');
  const isTricycle = get(transactionInfo, "attributes.type") === "TRICYCLE"
  const getVehicleCount = () => {
    let total = 0
    _.forEach(vehicleInfo, x => {total += x.attributes.vehicle_unit?.length} )
    return total
  }

  const unitStatusBadge = status => {

    if (status === 'PENDING') return (<span className='bg-warning px-2 rounded text-light'>{status}</span>)
    if (status === 'PASSED') return (<span className='bg-success px-2 rounded text-light'>{status}</span>)
    if (status === 'FAILED') return (<span className='bg-danger px-2 rounded text-light'>{status}</span>)
    
    return '---'
  }
  return (
    <>
      <div className="col-12 p-3">
        <p className="mb-2 font-weight-bold cms-text-primary" style={{ fontSize: '16px' }}>Vehicle Information</p>
        <table className="transaction-table table table-borderless table-striped table-sm">
          <tbody>
            <tr>
              <td className="text-dark font-weight-bold" width="250">No. of Case</td>
              <td />
              <td>
                <b>{(vehicleInfo?.length || '0')}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" width="250">No. of Vehicles</td>
              <td />
              <td>
                <b>{(getVehicleCount() || '0')}</b>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="mb-2 font-weight-bold cms-text-primary" style={{ fontSize: '16px' }}>Registrant Information</p>
        {!isTricycle && vehicleInfo?.map((item, index) => (
          <div key={+item.id}>
            <table width="100%" className="transaction-table table table-borderless table-striped table-sm">
              <thead className="table-header cms-text-primary ">
                <tr>
                  <td colSpan={3}><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>{`Case ${index + 1}`}</span></td>
                </tr>
              </thead>
              <tbody className="p-3">
                <tr>
                  <td className="text-dark font-weight-bold" width="250">LTFRB Case No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.ltfrb_case_no') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">Franchise Validity</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.franchise_validity') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">LTO OR No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.lto_or_no') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">LTO OR Validity</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.lto_or_validity') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">LTO CR No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.lto_cr_no') || '---'}</b></td>
                </tr>
              </tbody>
            </table>
            <table width="100%" className="transaction-table table table-striped table-sm">
              <thead className="table-header cms-text-primary ">
                <tr>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Make</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Plate No.</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Validity</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Actions</span></td>
                </tr>
              </thead>
              <tbody className="p-3">
                {(_.get(vehicleInfo, `${index}.attributes.vehicle_unit`) || []).map((unit) => (
                  <tr key={+unit.id}>
                    <td width="250" className="text-dark pl-4 align-middle">
                      {_.get(unit, 'make') || ''}
                    </td>
                    <td width="250" className="text-dark pl-4 align-middle">
                      {_.get(unit, 'plate_no') || ''}
                    </td>
                    <td width="1" className=" align-middle">
                      {unitStatusBadge(_.get(unit, 'validity') || 'PENDING')}
                    </td>
                    <td width="1" className=" align-middle">
                      {Acl(permissions, ['TOGGLE VEHICLE UNIT VALIDITY']) && 
                      get(transactionInfo, 'included.transaction_history.attributes.transaction_status') === 'FOR CHECKING' && 
                      isStartAssessment ? (
                        <>
                          <button type="button" className="btn-blank" onClick={handleTagUnit(_.get(unit, 'id'), "PASSED")}>
                            <i className="fas fa-check icon-check-alt" />
                          </button>
                          <button type="button" className="btn-blank" onClick={handleTagUnit(_.get(unit, 'id'), "FAILED")}>
                            <i className="fas fa-times icon-reject-alt" />
                          </button>
                        </>
                      ) : <span> --- </span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {isTricycle && vehicleInfo?.map((item, index) => (
          <div key={+item.id}>
            <table width="100%" className="transaction-table table table-borderless table-striped table-sm">
              <thead className="table-header cms-text-primary ">
                <tr>
                  <td colSpan={3}><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Vehicle</span></td>
                </tr>
              </thead>
              <tbody className="p-3">
                <tr>
                  <td className="text-dark font-weight-bold" width="250">MTH No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.mth_no') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">Motor No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.motor_no') || '---'}</b></td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" width="250">Chassis No.</td>
                  <td />
                  <td><b>{_.get(item, 'attributes.chassis_no') || '---'}</b></td>
                </tr>
              </tbody>
            </table>
            <table width="100%" className="transaction-table table table-striped table-sm">
              <thead className="table-header cms-text-primary ">
                <tr>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Make</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Plate No.</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Validity</span></td>
                  <td><span className="font-weight-bold cms-text-primary cms-bg-color-primary-light" style={{ fontSize: '16px' }}>Actions</span></td>
                </tr>
              </thead>
              <tbody className="p-3">
                {(_.get(vehicleInfo, `${index}.attributes.vehicle_unit`) || []).map((unit) => (
                  <tr key={+unit.id}>
                    <td width="250" className="text-dark pl-4 align-middle">
                      {_.get(unit, 'make') || ''}
                    </td>
                    <td width="250" className="text-dark pl-4 align-middle">
                      {_.get(unit, 'plate_no') || ''}
                    </td>
                    <td width="1" className=" align-middle">
                      {unitStatusBadge(_.get(unit, 'validity') || 'PENDING')}
                    </td>
                    <td width="1" className=" align-middle">
                      {Acl(permissions, ['TOGGLE VEHICLE UNIT VALIDITY']) && 
                      get(transactionInfo, 'included.transaction_history.attributes.transaction_status') === 'FOR CHECKING' && 
                      isStartAssessment ? (
                        <>
                          <button type="button" className="btn-blank" onClick={handleTagUnit(_.get(unit, 'id'), "PASSED")}>
                            <i className="fas fa-check icon-check-alt" />
                          </button>
                          <button type="button" className="btn-blank" onClick={handleTagUnit(_.get(unit, 'id'), "FAILED")}>
                            <i className="fas fa-times icon-reject-alt" />
                          </button>
                        </>
                      ) : <span> --- </span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </>
  );
};

VehicleInformation.defaultProps = {
};

VehicleInformation.propTypes = {
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  handleTagUnit: PropTypes.instanceOf(Function).isRequired,
  // module: PropTypes.string.isRequired,
};

export default VehicleInformation;
